// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/certapis/gen/buhta_cert_ncamodule_rpc_v1alpha1_module.ml",
      55,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [[
                                  {
                                    TAG: /* Module */0,
                                    _0: [
                                      [
                                        /* Function */0,
                                        "name"
                                      ],
                                      [
                                        /* Function */0,
                                        "to_int"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_int"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_int_exn"
                                      ],
                                      [
                                        /* Function */0,
                                        "to_string"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_string_exn"
                                      ]
                                    ]
                                  },
                                  "NcaModuleCommand"
                                ]]
                            },
                            "V1alpha1"
                          ]]
                      },
                      "Rpc"
                    ]]
                },
                "Ncamodule"
              ]]
          },
          "Cert"
        ]]
    });

const Cert = Caml_module.init_mod([
      "proto/certapis/gen/buhta_cert_ncamodule_rpc_v1alpha1_module.ml",
      81,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "NcaModuleCommand"
                          ]]
                      },
                      "V1alpha1"
                    ]]
                },
                "Rpc"
              ]]
          },
          "Ncamodule"
        ]]
    });

const Ncamodule = Caml_module.init_mod([
      "proto/certapis/gen/buhta_cert_ncamodule_rpc_v1alpha1_module.ml",
      105,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "NcaModuleCommand"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Rpc"
        ]]
    });

const Rpc = Caml_module.init_mod([
      "proto/certapis/gen/buhta_cert_ncamodule_rpc_v1alpha1_module.ml",
      127,
      12
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "NcaModuleCommand"
              ]]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/certapis/gen/buhta_cert_ncamodule_rpc_v1alpha1_module.ml",
      147,
      14
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "NcaModuleCommand"
        ]]
    });

const NcaModuleCommand = Caml_module.init_mod([
      "proto/certapis/gen/buhta_cert_ncamodule_rpc_v1alpha1_module.ml",
      165,
      16
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.cert.ncamodule.rpc.v1alpha1.NcaModuleCommand";
}

function to_int(param) {
  return param;
}

function from_int_exn(n) {
  if (n > 3 || n < 0) {
    return Ocaml_protoc_plugin__Result.raise({
                NAME: "Unknown_enum_value",
                VAL: n
              });
  } else {
    return n;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* NCA_MODULE_COMMAND_UNSPECIFIED */0 :
        return "NCA_MODULE_COMMAND_UNSPECIFIED";
    case /* NCA_MODULE_COMMAND_SELECT_SIGN_CERT */1 :
        return "NCA_MODULE_COMMAND_SELECT_SIGN_CERT";
    case /* NCA_MODULE_COMMAND_SIGN_DOCUMENT */2 :
        return "NCA_MODULE_COMMAND_SIGN_DOCUMENT";
    case /* NCA_MODULE_COMMAND_BULK_SIGN_DOCUMENT */3 :
        return "NCA_MODULE_COMMAND_BULK_SIGN_DOCUMENT";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "NCA_MODULE_COMMAND_BULK_SIGN_DOCUMENT" :
        return /* NCA_MODULE_COMMAND_BULK_SIGN_DOCUMENT */3;
    case "NCA_MODULE_COMMAND_SELECT_SIGN_CERT" :
        return /* NCA_MODULE_COMMAND_SELECT_SIGN_CERT */1;
    case "NCA_MODULE_COMMAND_SIGN_DOCUMENT" :
        return /* NCA_MODULE_COMMAND_SIGN_DOCUMENT */2;
    case "NCA_MODULE_COMMAND_UNSPECIFIED" :
        return /* NCA_MODULE_COMMAND_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, NcaModuleCommand, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "NcaModuleCommand"
        ]]
    }, V1alpha1, {
      NcaModuleCommand: NcaModuleCommand
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "NcaModuleCommand"
              ]]
          },
          "V1alpha1"
        ]]
    }, Rpc, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "NcaModuleCommand"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Rpc"
        ]]
    }, Ncamodule, {
      Rpc: Rpc
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "NcaModuleCommand"
                          ]]
                      },
                      "V1alpha1"
                    ]]
                },
                "Rpc"
              ]]
          },
          "Ncamodule"
        ]]
    }, Cert, {
      Ncamodule: Ncamodule
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [[
                                  {
                                    TAG: /* Module */0,
                                    _0: [
                                      [
                                        /* Function */0,
                                        "name"
                                      ],
                                      [
                                        /* Function */0,
                                        "to_int"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_int"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_int_exn"
                                      ],
                                      [
                                        /* Function */0,
                                        "to_string"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_string_exn"
                                      ]
                                    ]
                                  },
                                  "NcaModuleCommand"
                                ]]
                            },
                            "V1alpha1"
                          ]]
                      },
                      "Rpc"
                    ]]
                },
                "Ncamodule"
              ]]
          },
          "Cert"
        ]]
    }, Buhta, {
      Cert: Cert
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
